import React from "react";
import { Row, Col } from "reactstrap";

const Sorter = ({ toggleSort }) => {
  return (
    <>
      <Row className="g-0 d-flex justify-content-end">
        <Col
          xs={5}
          className="d-flex justify-content-center align-items-center responsive-fontsize small text-muted"
          style={{ cursor: "default" }}
        >
          Sortera åtgärder på:
        </Col>
      </Row>
      <Row className="g-0 d-flex justify-content-end">
        <Col xs={5} className="d-flex justify-content-end">
          <select
            className="sorter rounded-3"
            onChange={(e) => toggleSort(e.target.value)}
          >
            <option className="sorter-option" value="measureName">
              Åtgärdsnamn
            </option>
            <option className="sorter-option" value="prio">
              Prioritet
            </option>
            <option className="sorter-option" value="responsible">
              Ansvarig
            </option>
            <option className="sorter-option" value="hours1">
              Åtgärdstimmar År1
            </option>
            <option className="sorter-option" value="hours2">
              Åtgärdstimmar År2
            </option>
            <option className="sorter-option" value="hours3">
              Åtgärdstimmar År3
            </option>
            <option className="sorter-option" value="costs1">
              Finansieringsbehov År1
            </option>
            <option className="sorter-option" value="costs2">
              Finansieringsbehov År2
            </option>
            <option className="sorter-option" value="costs3">
              Finansieringsbehov År3
            </option>
            {/* <option className="sorter-option" value="startdate">
              Stardatum
            </option> */}
          </select>
        </Col>
      </Row>
    </>
  );
};
export default Sorter;
